module.exports = __webpack_public_path__ + "assets/webgl/Assets_2_base_color.jpg.pvr.289494c1.ktx";